import type { ReactNode } from "react";
import { Reveal } from "./Reveal";
import { MonoLabel } from "./primitives";

interface SectionHeaderProps {
  index: string;
  label: string;
  title: ReactNode;
  description?: string;
  align?: "left" | "center";
}

export function SectionHeader({ index, label, title, description, align = "left" }: SectionHeaderProps) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      <div className={align === "center" ? "flex flex-col items-center" : ""}>
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-cyan/50" />
          <MonoLabel>
            {index} · {label}
          </MonoLabel>
          {align === "center" && <span className="h-px w-8 bg-cyan/50" />}
        </div>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-ink sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        {description && (
          <p className={`mt-5 max-w-2xl text-base leading-relaxed text-dim ${align === "center" ? "mx-auto" : ""}`}>
            {description}
          </p>
        )}
      </div>
    </Reveal>
  );
}
